// src/components/Auth/ProtectedRoute.js
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

// Dev-only auth bypass. Set `REACT_APP_ENABLE_AUTH=false` in .env.local
// for fast lab iteration. The flag lives in config/authBypass.js —
// shared with AuthContext, which supplies the synthetic guest user.
// NEVER ship a build with this flag false to production — the flag
// itself requires NODE_ENV !== 'production' so a leaked .env can't
// accidentally open prod.
import { AUTH_BYPASS } from '../../config/authBypass';

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (AUTH_BYPASS) {
    return children;
  }

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-900">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mx-auto mb-4"></div>
          <div className="text-white">Loading...</div>
        </div>
      </div>
    );
  }

  if (!user) {
    // Redirect to login page but save the attempted location
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
}

